import React from "react";

class GetStartedOutputComponent extends React.Component<{}> {
    render(): React.ReactNode {
        return <p>Enter at least one team number and a range of years to get started. Include more than one team to see statistics for the group.</p>
    }
}

export default GetStartedOutputComponent